import { apiRemote } from '../../../../Services/RemoteService';
import {
  mockGetBatchSyndicationResponse,
  mockSyndicationCommunities,
} from '../mocks';
import {
  getQueryString,
  normalizeBatchSyndicationResponse,
  normalizePropertiesSyndication,
  normalizeSyndicationCommunities,
  normalizeSyndicationProperties,
  transformPatchSubscription,
} from './utils';

export const SYNDICATION_UPDATE_ERROR =
  'Failed to update syndication subscription';
export const SYNDICATION_GET_ERROR = 'Failed to get syndication subscription';

export const getPaginatedSyndicationSubscriptions = async (
  queryParams = {}
) => {
  const queryString = getQueryString(queryParams);
  try {
    const response = await apiRemote.get(
      `admin/syndication/properties/subscriptions/paginated${queryString}`
    );

    if (!response.ok || response.status !== 200) {
      throw new Error();
    }

    const {
      properties = [],
      subscriptions: channels = {},
      count: totalPropertyCount = 0,
    } = await response.json();

    const normalizedProperties = normalizeSyndicationProperties(properties);

    const { activeChannels, propertiesSyndication } =
      normalizePropertiesSyndication(channels, normalizedProperties);

    return {
      activeChannels,
      propertiesSyndication,
      totalPropertyCount,
    };
  } catch {
    throw new Error(SYNDICATION_GET_ERROR);
  }
};
export const getAllSyndicationSubscriptions = async () => {
  try {
    const response = await apiRemote.get(
      `admin/syndication/properties/subscriptions/paginated`
    );

    if (!response.ok || response.status !== 200) {
      throw new Error();
    }

    const {
      properties = [],
      subscriptions = {},
      count: totalPropertyCount = 0,
    } = await response.json();

    return {
      properties: normalizeSyndicationProperties(properties),
      subscriptions: subscriptions,
      totalPropertyCount,
    };
  } catch (_e) {
    throw new Error(SYNDICATION_GET_ERROR);
  }
};

export const getBatchSyndicationSubscriptions = async (payload) => {
  try {
    const response = await apiRemote.post(
      `admin/syndication/properties/subscriptions`,
      payload
    );

    if (!response.ok || response.status !== 200) {
      throw new Error();
    }
    const syndicationResponse = await response.json();
    const normalizedResponse =
      normalizeBatchSyndicationResponse(syndicationResponse);

    return normalizedResponse;
  } catch (_e) {
    return normalizeBatchSyndicationResponse(mockGetBatchSyndicationResponse);
  }
};

export const getSyndicationCommunityList = async () => {
  try {
    const response = await apiRemote.get('admin/properties/community-list');

    if (!response.ok || response.status !== 200) {
      throw new Error();
    }

    const { communities = [] } = await response.json();
    return {
      communities: normalizeSyndicationCommunities(communities),
    };
  } catch (_e) {
    return {
      communities: normalizeSyndicationCommunities(mockSyndicationCommunities),
    };
  }
};

export const updateSyndicationSubscription = async (payload) => {
  const transformedPayload = transformPatchSubscription(payload);

  try {
    const response = await apiRemote.patch(
      'admin/syndication/properties/subscribe',
      transformedPayload
    );

    if (!response.ok || response.status !== 204) {
      throw new Error();
    }
  } catch (_e) {
    throw new Error(SYNDICATION_UPDATE_ERROR);
  }
};
